import { customerMessagingSessionSchema, staffMessagingSessionSchema, } from "@lafayette/schemas";
import { ApiHttpError, ApiNetworkError, ApiResponseError } from "./api-failure";
import { createJsonTransport } from "./json-transport";
/** The API answered with an error status. */
export class MessagingApiError extends ApiHttpError {
    constructor(status, code, message, requestId, retryAfter) {
        super(status, code, message, requestId, retryAfter);
        this.name = "MessagingApiError";
    }
}
/** The request never got an answer (no network, DNS, a closed connection). */
export class MessagingApiNetworkError extends ApiNetworkError {
    constructor(options) {
        super("the messaging API could not be reached", options);
        this.name = "MessagingApiNetworkError";
    }
}
/** The API answered 2xx with a body that does not match the contract (an extra key counts: the schemas are strict). */
export class MessagingApiResponseError extends ApiResponseError {
    constructor() {
        super("the messaging API answered with an unexpected body");
        this.name = "MessagingApiResponseError";
    }
}
export function createMessagingSessionApi(options) {
    const send = createJsonTransport(options, {
        refusedMessage: "the messaging API refused the request",
        network: (cause) => new MessagingApiNetworkError({ cause }),
        response: () => new MessagingApiResponseError(),
        http: ({ status, code, message, requestId, retryAfter }) => new MessagingApiError(status, code, message, requestId, retryAfter),
    });
    // The session call is idempotent on the server and the Stream token provider calls it again, so it makes no retry of its own and
    // sends no `Idempotency-Key`.
    const open = (path, schema, callOptions) => send({
        method: "POST",
        path,
        schema,
        command: false,
        maxNetworkRetries: 0,
        signal: callOptions?.signal,
    });
    return {
        openCustomerSession: (callOptions) => open("/customer/messaging/session", customerMessagingSessionSchema, callOptions),
        openStaffSession: (callOptions) => open("/staff/messaging/session", staffMessagingSessionSchema, callOptions),
    };
}
